import React from 'react';
import { useIntl } from 'react-intl';
import type { StockItemDefaultValuesType, StockItemFormUsagePurposeType } from '../entity';
import StockItemForm from './stock-item-form/stock-item-form';
import StockTutorial from '/public/assets/images/stock_tutorial.png';
import { useStockItemForm } from './stock-item-form/stock-item-form.hooks';
import { ImperativeFormDialogRefType } from '@shared/components/UserFormDialog';
import { SubmitFormDialog } from '@shared/components/dialogs/submit-form-dialog';
import FullScreenImage from '@shared/components/FullscreenImage';

type StockItemFormDialogProps = {
  defaultValues?: Partial<StockItemDefaultValuesType>;
  formUsagePurpose: StockItemFormUsagePurposeType;
  dialogRef: React.Ref<ImperativeFormDialogRefType>;
};

export const StockItemFormDialog = (props: StockItemFormDialogProps) => {
  const { defaultValues, formUsagePurpose, dialogRef } = props;
  const intl = useIntl();

  const {
    methods,
    stocks,
    isPurchaseStockItem,
    setIsPurchaseStockItem,
    stockItem: { unit, avgUnitPrice, lastPackageQuantity },
    createOrUpdateStockItemMutation,
  } = useStockItemForm(defaultValues);

  return (
    <SubmitFormDialog<StockItemDefaultValuesType>
      methods={methods}
      ref={dialogRef}
      onSubmit={data => createOrUpdateStockItemMutation({ ...data, stockId: stocks![0].id })}
      actions={<FullScreenImage src={StockTutorial} />}
      title={intl.formatMessage({
        defaultMessage: 'Upravit skladovou zásobu',
        id: 'stockItem.editStockItem',
      })}
    >
      <StockItemForm
        methods={methods}
        isPurchaseStockItem={isPurchaseStockItem}
        setIsPurchaseStockItem={setIsPurchaseStockItem}
        formUsagePurpose={formUsagePurpose}
        stockItem={{ lastPackageQuantity, unit, avgUnitPrice }}
      />
    </SubmitFormDialog>
  );
};
